// Write your code here
import './index.css'
import {Component} from 'react'
import Loader from 'react-loader-spinner'
import LatestMatch from '../LatestMatch'
import MatchCard from '../MatchCard'

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

class TeamMatches extends Component {
  state = {isLoading: true, dataList: [], url: '', latestMatch: {}}

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const {match} = this.props
    const {params} = match
    const {id} = params
    console.log(id)
    const response = await fetch(`https://apis.ccbp.in/ipl/${id}`)
    const data = await response.json()

    const teamBannerUrl = data.team_banner_url
    console.log(teamBannerUrl)
    const latestMatchDetails = {
      umpires: data.latest_match_details.umpires,
      result: data.latest_match_details.result,
      manOfTheMatch: data.latest_match_details.man_of_the_match,
      id: data.latest_match_details.id,
      date: data.latest_match_details.date,
      venue: data.latest_match_details.venue,
      competingTeam: data.latest_match_details.competing_team,
      competingTeamLogo: data.latest_match_details.competing_team_logo,
      firstInnings: data.latest_match_details.first_innings,
      secondInnings: data.latest_match_details.second_innings,
      matchStatus: data.latest_match_details.match_status,
    }

    const ModifiedmatachesData = data.recent_matches.map(every => ({
      umpires: every.umpires,
      result: every.result,
      manOfTheMatch: every.man_of_the_match,
      id: every.id,
      date: every.date,
      venue: every.venue,
      competingTeam: every.competing_team,
      competingTeamLogo: every.competing_team_logo,
      firstInnings: every.first_innings,
      secondInnings: every.second_innings,
      matchStatus: every.match_status,
    }))

    this.setState({
      url: teamBannerUrl,
      dataList: ModifiedmatachesData,
      latestMatch: latestMatchDetails,
      isLoading: false,
    })
  }

  toRender = () => {
    const {url, latestMatch, dataList} = this.state

    return (
      <div className="teamMatches">
        <img className="teamImage" src={url} alt="team banner" />
        <p>Latest Matches</p>
        <LatestMatch latestMatch={latestMatch} />
        <ul className="matchcards_Container">
          {dataList.map(every => (
            <MatchCard key={every.id} details={every} />
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const {isLoading} = this.state
    return isLoading ? (
      <div>
        <Loader type="Oval" color="#ffffff" height={50} width={50} />{' '}
      </div>
    ) : (
      this.toRender()
    )
  }
}

export default TeamMatches
